/* import __COLOCATED_TEMPLATE__ from './predicates-editor-side-sheet.hbs'; */
/* RESPONSIBLE TEAM: team-ml */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { action } from '@ember/object';
//@ts-ignore no type declaration available for ember-copy
import { copy } from 'ember-copy';
//@ts-ignore no type declaration available for predicates
import type ReactTeammateAppIslandService from 'embercom/services/react-teammate-app-island';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    onClose: () => void;
    isOpen: boolean;
    routingOutcomeId?: string;
    predicateGroup?: $TSFixMe;
  };
}

export default class PredicatesEditorSideSheet extends Component<Signature> {
  @service declare attributeService: $TSFixMe;
  @service declare intl: $TSFixMe;
  @service declare reactTeammateAppIsland: ReactTeammateAppIslandService;

  get attributeGroupList() {
    // Workflow collectable attributes excluding Fin Attributes (classification attributes)
    let collectableAttributes = this.attributeService.botAutoMessageCollectableAttributes.filter(
      (attr: any) => !attr.isClassificationAttribute,
    );

    let regularGroups = this.attributeService.attributesToGroupList(collectableAttributes);

    let naturalLanguageAttribute = {
      identifier: 'llm_evaluation',
      name: this.intl.t(
        'ai-agent.sales-development.predicates-editor-side-sheet.natural-language-condition',
      ),
      type: 'llm_evaluation',
      icon: null,
    };

    let naturalLanguageGroup = {
      heading: null,
      attributes: [naturalLanguageAttribute],
    };

    return [naturalLanguageGroup, ...regularGroups];
  }

  get predicateContext() {
    return {
      mode: 'fin-sdr',
    };
  }

  @action
  onPredicatesUpdate(predicates: any[]) {
    if (!this.args.predicateGroup) {
      return;
    }

    this.args.predicateGroup.set('predicates', copy(predicates));
  }

  @action
  savePredicates() {
    if (!this.args.predicateGroup) {
      return;
    }

    let predicates = this.args.predicateGroup.predicates.serialize() || [];

    this.reactTeammateAppIsland.dispatchBridgeEvent('teammate-app:event', {
      identifier: 'fin-sdr:predicates:updated',
      data: {
        routingOutcomeId: this.args.routingOutcomeId,
        predicates,
      },
    });

    this.args.onClose();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::SalesDevelopment::PredicatesEditorSideSheet': typeof PredicatesEditorSideSheet;
    'ai-agent/sales-development/predicates-editor-side-sheet': typeof PredicatesEditorSideSheet;
  }
}
